import React, { useEffect, useState } from "react"
import dayjs from "dayjs"
import "dayjs/locale/fr"
import { FaCheckCircle, FaUserCircle } from "react-icons/fa"

import { Row, Col, Button } from "reactstrap"

import "chartist/dist/scss/chartist.scss"
import dashboardImage from "../../../../src/assets/images/playMakerImage.png"
import jsk from "../../../../src/assets/images/jsk.png"

//i18n
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { API_URL } from "constants/ApiUrl"
import VerifieCompteClub from "pages/Club/profile/componants/VerifieCompteClub"

const Header = () => {
  dayjs.locale("fr")
  const [ProfileImage, setProfileImage] = useState(null)
  const { club } = useSelector((state) => state.Club)
  const navigate = useNavigate()
  useEffect(() => {
    if (club?.logo) {
      const cleanApiUrl = API_URL.replace(/\/+$/, '');

      let cleanLogo = club.logo.replace(/\\/g, '/').replace(/^\/+/, '');

      if (!cleanLogo.startsWith('uploads/')) {
        cleanLogo = 'uploads/' + cleanLogo;
      }
      setProfileImage(`${cleanApiUrl}/${cleanLogo}`);
    }
  }, [club]);
  return (
    <Row>
      <Col
        sm={12}
        md={12}
        lg={4}
        xl={4}
        style={{
          justifyItems: "center",
          marginBottom: "10px",
        }}
      >
        <div
          className="d-flex align-items-center mb-4"
          style={{ height: "45%" }}
        >
          <div className="me-3">
            {
              ProfileImage ?
                <img
                  src={ProfileImage}
                  alt="JSK Logo"
                  className="img-fluid"
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "contain",
                  }}
                />
                :
                <FaUserCircle size={64} className="text-secondary" />
            }

          </div>
          <div>
            <h5 className="mb-1" style={{ font: "Visby CF", color: "#000000" }}>
              {club?.nameFr}
            </h5>
            {club?.createdAt && (
              <p className="text-muted mb-2">
                Actif depuis {dayjs(club.createdAt).format("MMMM YYYY")}
              </p>
            )}
            <Button
              style={{
                backgroundColor: "#157088B2",
                font: "Visby CF",
                borderRadius: 5,
              }}
              className="btn btn-primary btn-sm"
              onClick={() => {
                navigate("/profile")
              }}
            >
              Modifier le profile
            </Button>
          </div>
        </div>

        <div
          style={{
            height: "55%",
            width: "70%",
          }}
        >
          <p style={{ font: "Visby CF", color: "#000000" }}>
            Pour garantir la fiabilité et la sécurité sur la plateforme, nous
            vous demandons de vérifier votre compte.
          </p>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              // justifyContent: "center",
              marginBottom: 20,
            }}
          >
            {/* <a
              href="/details"
              className="text-primary"
              style={{
                color: "#157088",
                textDecoration: "underline", // Souligner le lien
                display: "flex",
                alignItems: "center", // Aligner l'icône et le texte horizontalement
              }}
            >
              vérifier votre compte
            </a>
            <FaCheckCircle style={{ marginLeft: "8px" }} /> */}
            <VerifieCompteClub />
          </div>
        </div>
      </Col>

      <Col
        sm={12}
        md={12}
        lg={8}
        xl={8}
        className="text-center"
        style={{ marginTop: 10 }}
      >
        <img src={dashboardImage} alt="Tableau de bord" className="img-fluid" />
      </Col>
    </Row>
  )
}

export default Header
